/**
 * @class {RoadgamesEvent.Base}
 * @extends {mkE.Base}
 * @param {DR.events.struct.Event} event
 * @param {DR.events.struct.Stats} stats
 * @param {DR.events.struct.DiscountData|null} discountData
 */
RoadgamesEvent.Base = Class(
	/**
	 * @lends {RoadgamesEvent.Base#}
	 */
	{
		__NAME: 'RoadgamesEvent.Base',

		/** @type {DR.events.struct.Event} */
		event: null,
		/** @type {DR.events.struct.Stats} */
		stats: null,
		/** @type {DR.events.struct.Livestream} */
		livestream: null,
		/** @type {DR.events.struct.DiscountData|null} */
		discountData: null,

		state: 'base',

		isRace: false,

		_galleries: [],

		/**
		 * @param {DR.events.struct.Event} event
		 * @param {DR.events.struct.Stats} stats
		 * @param {DR.events.struct.DiscountData|null} discountData
		 * @param {DR.events.struct.Livestream|null} livestream
		 * @constructor
		 */
		__construct( event, stats, discountData, livestream ) {
			this.event = event;
			this.stats = stats;
			this.livestream = livestream;
			this.discountData = discountData;
			this.isRace = this.event.settings.gameType === 'race';

			this.node = mkE({
				tag: 'div',
				className: 'event-page single-event single-event-' + this.state
			});

			this._draw();
		},

		/**
		 * @abstract
		 */
		_draw() {
		},

		_drawWelcome() {
			let welcome = mkE({
				tag: 'div',
				className: 'container single-event-welcome',
				els: [
					{
						tag: 'div',
						className: 'single-event-block',
						els: [
							this.event.hasPartnerImage ? {
								tag: 'img',
								className: 'partnerImage',
								src: this.event.partnerImage.original
							} : null,
							{
								tag: 'h1',
								className: 'title',
								text: this.event.title
							},
							this._drawRating(),
							this._drawWelcomeBottom(),
							this._shareNode = this._drawShare(),
							this.event.isAdmin ? {
								tag: 'a',
								className: 'admin noAjax',
								href: `/admin/events/${this.event.seoTitle}/landing`,
								text: 'Event admin'
							} : ''
						]
					}
				]
			});

			let image = this.event.landing.pic ? this.event.landing.pic.large : null;
			if( screen.width < 720 ) {
				if( this.event.landing.picMobile ) {
					image = this.event.landing.picMobile.original;
				} else if( this.event.hasImage ) {
					image = this.event.image.original;
				}
			}
			let video = null;
			if( this.event.landing.video ) {
				video = this.event.landing.video.url;
				if( screen.width < 720 && this.event.landing.videoMobile ) {
					video = this.event.landing.videoMobile.url;
				}
			}

			mkE({
				tag: 'div',
				id: 'single-event-background',
				els: [
					{
						tag: 'div',
						id: 'single-event-background-picture',
						style: image ? {
							backgroundImage: 'url(' + image + ')'
						} : {},
						els: [
							video ? {
								tag: 'video',
								src: video,
								attr: {
									preload: 'auto',
									muted: true,
									autoplay: true,
									loop: true,
									playsinline: true
								},
								oncanplaythrough: function () {
									this.muted = true;
									try {
										this.play();
									} catch( e ) {
									}
								}
							} : null
						]
					},
					welcome
				]
			}).append(this.node);
		},

		_onClickInfoMenu( e ) {
			e.preventDefault();
			const el = document.getElementById(e.target.hash.substr(1));
			if( el ) {
				D.scrollIntoView(el, null, 150);
			}
		},

		_drawInfoBlock() {
			let menu;
			if( this.isRace ) {
				menu = [
					{
						tag: 'li',
						els: [{
							tag: 'a',
							href: '#event-region-map',
							onclick: this._onClickInfoMenu,
							text: D.Lang.get('event.infoblock.menu.territory')
						}]
					},
					{
						tag: 'li',
						els: [{
							tag: 'a',
							href: '#how-to-play-new',
							onclick: this._onClickInfoMenu,
							text: D.Lang.get('event.infoblock.menu.tasks')
						}]
					},
					{
						tag: 'li',
						els: [{
							tag: 'a',
							href: '#game-steps',
							onclick: this._onClickInfoMenu,
							text: D.Lang.get('event.infoblock.menu.how-to')
						}]
					}
				];

				if( this.event.settings.hasLivestream ) {
					menu.push({
						tag: 'li',
						els: [{
							tag: 'a',
							href: '#prize-sponsors',
							onclick: this._onClickInfoMenu,
							text: D.Lang.get('event.infoblock.menu.live_awards')
						}]
					});
				}

			} else {
				menu = [
					{
						tag: 'li',
						els: [{
							tag: 'a',
							href: '#gallery',
							onclick: this._onClickInfoMenu,
							text: D.Lang.get('event.infoblock.menu.gallery')
						}]
					},
					{
						tag: 'li',
						els: [{
							tag: 'a',
							href: '#how-to-play-new',
							onclick: this._onClickInfoMenu,
							text: D.Lang.get('event.infoblock.menu.tasks')
						}]
					},
					{
						tag: 'li',
						els: [{
							tag: 'a',
							href: '#game-steps',
							onclick: this._onClickInfoMenu,
							text: D.Lang.get('event.infoblock.menu.how-to')
						}]
					},
					{
						tag: 'li',
						els: [{
							tag: 'a',
							onclick: () => {
								this.gallery.openGallery(0);
							},
							text: D.Lang.get('event.infoblock.menu.territory')
						}]
					}
				];
			}

			const date = this._getEventDate();
			if( date && !(this instanceof RoadgamesEvent.InProgress && this.isRace) ) {
				mkE({
					tag: 'div',
					id: 'single-event-date',
					className: 'container',
					els: [
						date,
						new T.AddToCalendar({
							startDate: this.event.startTime,
							endDate: this.event.endTime,
							title: this.event.title,
							description: this.event.description,
							location: `${this.event.settings.regionCenter.latitude.toFixed(5)},${this.event.settings.regionCenter.longitude.toFixed(5)}`,
							url: D.url('/event/' + this.event.seoTitle, D.LANG, true)
						})
					]
				}).append(this.node);
			}

			mkE({
				tag: 'div',
				id: 'single-event-infoblock',
				els: [
					{
						tag: 'div',
						className: 'container',
						els: [
							{
								tag: 'div',
								className: 'menu',
								els: [
									{
										tag: 'div',
										className: 'title',
										text: D.Lang.get('event.infoblock.menu.title')
									},
									{
										tag: 'ul',
										els: menu
									}
								]
							},
							{
								tag: 'div',
								className: 'info',
								els: [
									{
										tag: 'div',
										className: 'quick',
										els: [
											this.event.stats.pins > 0 ? {
												tag: 'div',
												className: 'item',
												els: [
													{
														tag: 'div',
														className: 'label',
														text: D.Lang.get('event.infoblock.quick.pins')
													},
													{
														tag: 'div',
														className: 'icon',
														els: [
															{
																tag: 'span',
																className: 'icon-box',
																els: [
																	D.svgIcon('pins')
																]
															},
															this.event.stats.pins
														]
													}
												]
											} : '',
											this.event.settings.transportType !== 'virtual' ? {
												tag: 'div',
												className: 'item',
												els: [
													{
														tag: 'div',
														className: 'label',
														text: D.Lang.get('event.infoblock.quick.transportType')
													},
													{
														tag: 'div',
														className: 'icon icon-transport',
														els: [
															{
																tag: 'span',
																className: 'icon-box',
																els: [
																	D.svgIcon('transport-type-' + this.event.settings.transportType)
																]
															},
															D.Lang.get('event.transport.' + this.event.settings.transportType)
														]
													}
												]
											} : '',
											this.event.stats.distance > 0 ? {
												tag: 'div',
												className: 'item',
												els: [
													{
														tag: 'div',
														className: 'label',
														text: D.Lang.get('event.infoblock.quick.distance')
													},
													{
														tag: 'div',
														className: 'icon icon-time',
														els: [
															{
																tag: 'span',
																className: 'icon-box',
																els: [
																	D.svgIcon('distance')
																]
															},
															Math.round(this.event.stats.distance / 1000) + ' km'
														]
													}
												]
											} : '',
											{
												tag: 'div',
												className: 'item',
												//title: D.Lang.get('event.infoblock.quick.gameLength.info'),
												els: [
													{
														tag: 'div',
														className: 'label',
														text: D.Lang.get('event.infoblock.quick.gameLength')
													},
													{
														tag: 'div',
														className: 'icon icon-time',
														els: [
															{
																tag: 'span',
																className: 'icon-box',
																els: [
																	D.svgIcon('time')
																]
															},
															RoadgamesEvent.getEventDuration(this.event)
														]
													}
												]
											},
											{
												tag: 'div',
												className: 'item',
												//title: D.Lang.get('event.infoblock.quick.tean.info'),
												els: [
													{
														tag: 'div',
														className: 'label',
														text: D.Lang.get('event.infoblock.quick.team')
													},
													{
														tag: 'div',
														className: 'icon icon-team',
														els: [
															{
																tag: 'span',
																className: 'icon-box',
																els: [
																	D.svgIcon('team')
																]
															},
															this.event.minPlayers === this.event.maxPlayers ? `${this.event.maxPlayers}` : `${this.event.minPlayers}-${this.event.maxPlayers}`
														]
													}
												]
											},
											{
												tag: 'div',
												className: 'item',
												els: [
													{
														tag: 'div',
														className: 'label',
														text: D.Lang.get('event.infoblock.quick.langauge')
													},
													{
														tag: 'div',
														className: 'icon icon-lang',
														els: [
															{
																tag: 'span',
																className: 'icon-box',
																els: [
																	D.svgIcon('languages')
																]
															},
															this.event.languages.join(', ')
														]
													}
												]
											}
										]
									},
									!in_array(D.LANG, this.event.languages) ? {
										tag: 'div',
										className: 'lang',
										els: [
											D.svgIcon('round-info'),
											' ',
											D.Lang.get('event.lang-notice').replace('%LANGUAGES%', (() => {
												let re = [];
												this.event.languages.forEach(lang => {
													re.push(D.Lang.get('iso.language.dat.' + lang).toLowerCase());
												});
												return re.join(', ');
											})())
										]
									} : '',
									this._eventDescriptionNode = mkE({
										tag: 'div',
										className: 'text'
									})
								]
							}
						]
					},
					this.isRace ? {
						tag: 'div',
						className: 'container',
						els: [
							{
								tag: 'a',
								id: 'event-region-map',
								className: 'region-image',
								onclick: () => {
									T.Popup.Gallery.open([this.event.regionImage.large]);
								},
								style: {backgroundImage: `url('${this.event.regionImage.large}')`},
								els: [
									{tag: 'small', text: D.Lang.get('event.infoblock.region.title')},
									{tag: 'p', text: this.event.region}
								]
							}
						]
					} : null
				]
			}).append(this.node);
		},

		_checkDescriptionLength() {
			if( this._eventDescriptionNode ) {
				const textNode = mkE({
					tag: 'div',
					className: 'description-container',
					els: [{
						tag: 'p',
						innerHTML: this.event.description
					}]
				}).append(this._eventDescriptionNode);
				nl2br(textNode.firstChild);
				if( this.isRace || textNode.firstChild.offsetHeight > textNode.offsetHeight ) {
					addClassName(textNode, 'clamped');
					mkE({
						tag: 'a',
						className: 'btn-expand',
						onclick: () => {
							toggleClassName(this._eventDescriptionNode, 'expanded');
						},
						text: D.Lang.get('events.infoblock.description.expand')
					}).append(this._eventDescriptionNode);
					mkE({
						tag: 'a',
						className: 'btn-contract',
						onclick: () => {
							toggleClassName(this._eventDescriptionNode, 'expanded');
						},
						text: D.Lang.get('events.infoblock.description.contract')
					}).append(this._eventDescriptionNode);
				}
			}
		},

		_getEventDate() {
			if( this.event.settings.hasUnknownDate ) {
				return D.Lang.get('event.welcome.soon');
			}
			if( this.event.startTime > D.TIME ) {
				let startDate = new D.Date(this.event.startTime);
				if( this.event.settings.gameType === 'race' ) {
					let endDate = new D.Date(this.event.endTime);
					let endFormat = '%H:%i';
					if( startDate.getMonth() !== endDate.getMonth() || startDate.getDate() !== endDate.getDate() ) {
						endFormat = D.Lang.get('events.list.dateFormat') + ', %H:%i';
					}
					return startDate.format2(D.Lang.get('events.list.dateFormat') + ', %H:%i').toUpperCase() + '-' + endDate.format2(endFormat).toUpperCase();
				} else {
					return startDate.format2(D.Lang.get('events.list.dateFormat') + ', %H:%i').toUpperCase();
				}
			}
			return '';
		},

		_getWelcomeText() {
			return this.event.description;
		},

		_drawRating() {
			const event = this.event;
			if( this.isRace && (this instanceof RoadgamesEvent.Finished || this instanceof RoadgamesEvent.InProgress) ) {
				return null;
			}
			if( event.startTime < D.TIME && event.stats.players >= 10 ) {
				return {
					tag: 'div',
					className: 'rating',
					els: [
						D.svgIcon('star'),
						{
							tag: 'span',
							els: [
								{
									tag: 'b',
									text: event.userRating.rating ? event.userRating.rating.toFixed(2) : '-'
								},
								event.userRating.users ? ' (' + event.userRating.users + ')' : ''
							]
						},
						' · ',
						D.Lang.nget(event.stats.players, 'event.users_played')
					]
				};
			} else if( this.isRace && event.stats.players > 10 ) {
				return formatTextNode(mkE({
					tag: 'div',
					className: 'rating rating-new',
					els: [
						D.Lang.get('event.rating.registered').replace('%PLAYERS%', event.stats.players)
					]
				}));
			} else if( !event.showResults ) {
				return {
					tag: 'div',
					className: 'rating rating-new',
					els: [
						D.svgIcon('star'),
						{
							tag: 'span',
							els: [
								{
									tag: 'b',
									text: D.Lang.get('events.new_event')
								}
							]
						},
						event.stats.players > 10 ? {
							tag: 'span',
							els: [
								' · ',
								D.Lang.nget(event.stats.players, 'event.users_played')
							]
						} : ''
					]
				};
			}
		},

		_drawWelcomeBottom() {
			return ''
		},

		_drawSteps() {
			let eventType = 'explore';
			if( this.isRace ) {
				eventType = 'race_' + this.event.settings.transportType;
			}
			mkE({
				tag: 'div',
				id: "game-steps",
				className: 'container single-event-steps',
				els: [
					{
						tag: 'div',
						className: 'single-event-block',
						els: [
							{
								tag: 'h2',
								className: 'title',
								text: D.Lang.get('event.steps.title')
							},
							{
								tag: 'p',
								className: 'text',
								els: [
									D.Lang.get('event.steps.text.' + eventType),
									{
										tag: 'br'
									},
									{
										tag: 'a',
										href: D.url('/terms/' + (this.isRace ? this.event.seoTitle : '')),
										text: D.Lang.get('event.steps.rules')
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'info',
						els: [
							{
								tag: 'div',
								className: 'column',
								els: [
									this._drawStepsInfo(eventType)
								]
							},
							{
								tag: 'div',
								className: 'column',
								els: [
									{
										tag: 'div',
										className: 'game-info'
									}
								]
							}
						]
					}
				]
			}).append(this.node);
		},

		_drawStepsInfo( eventType ) {
			return mkE({
				tag: 'div',
				className: 'steps',
				els: [
					this._drawStepInfo('register', eventType, [
						{
							pattern: '%PARTICIPANTS%',
							value: this._getEventParticipantInfo()
						},
						{
							pattern: '%MAX_PARTICIPANTS%',
							value: this.event.maxPlayers
						},
						{
							pattern: '%MIN_PARTICIPANTS%',
							value: this.event.minPlayers
						}
					]),
					this._drawStepInfo('ready', eventType),
					this._drawStepInfo('begin', eventType, [
						{
							pattern: '%DURATION%',
							value: RoadgamesEvent.getEventDuration(this.event, ' ' + D.Lang.get('event.steps.info.replacements.hours'))
						},
						{
							pattern: '%TRANSPORT_TYPE%',
							value: D.Lang.get('event.steps.info.replacements.transport_type.' + this.event.settings.transportType) // @todo eh
						}
					]),
					this._drawStepInfo('finish', eventType)
				]
			});
		},

		_drawStepInfo( step, eventType, replaces ) {
			let key = 'event.steps.info.list.' + step + '.' + eventType;
			let text = D.Lang.rget(key + '.text', replaces);
			let els = [];
			let parts = text.split("\n");
			for( let i = 0; i < parts.length; i++ ) {
				els.push({tag: 'li', text: parts[i]})
			}
			return mkE({
				tag: 'div',
				className: 'step step-' + step,
				els: [
					{
						tag: 'div',
						className: 'image'
					},
					{
						tag: 'div',
						className: 'data',
						els: [
							{
								tag: 'div',
								className: 'caption',
								text: D.Lang.rget(key + '.title', replaces)
							},
							{
								tag: 'div',
								className: 'text',
								els: [
									{
										tag: 'ul',
										className: 'default-list default-list-small',
										els: els
									}
								]
							}
						]
					}
				]
			})
		},

		_getEventParticipantInfo() {
			if( this.event.minPlayers === this.event.maxPlayers ) {
				return this.event.minPlayers;
			}
			return this.event.minPlayers + '-' + this.event.maxPlayers;
		},

		_showTasks: function () {
			this.tasksSlider.node.querySelector('.anchor').scrollIntoView({
				behavior: 'smooth'
			});
		},

		_drawSocials: function () {
			mkE({
				tag: 'div',
				className: 'container home-socials',
				els: [
					T.SocialIcons()
				]
			}).append(this.node);
		},

		_drawTasksSlider: function () {
			let tasks = RoadgamesEvent.getEventTasks(this.event);
			mkE({
				tag: 'div',
				className: 'how-to-wrapper',
				els: [
					this._howTo = new T.HowTo(
						tasks,
						tasks.includes('matchmaker') ? 'matchmaker' : tasks[0],
						this.event.settings.navigateWithStreetView,
						D.Lang.get('how-to.race.h2').replace('%COUNT%', tasks.length),
						this.event.title
					)
				]
			}).append(this.node);
		},

		_drawSponsors: function () {
			if( !this.event.sponsors.main.length && !this.event.sponsors.other.length ) {
				return;
			}
			mkE({
				tag: 'div',
				className: 'container event-sponsors-container',
				els: [
					this._drawMainSponsors(),
					this._drawOtherSponsors()
				]
			}).append(this.node);
		},

		_drawMainSponsors() {
			if( !this.event.sponsors.main.length ) {
				return null;
			}
			let sponsors = mkE({
				tag: 'div',
				className: 'event-sponsors'
			});
			this.event.sponsors.main.forEach(sponsor => {
				mkE({
					tag: 'div',
					className: 'event-sponsor',
					els: [
						{
							tag: 'img',
							src: sponsor.image.original,
							attr: {
								alt: sponsor.name
							}
						}
					]
				}).append(sponsors);
			});
			return mkE({
				tag: 'div',
				className: 'event-sponsors-main',
				els: [
					{
						tag: 'h2',
						className: 'h1',
						text: D.Lang.get('event.sponsors.main_title')
					},
					sponsors
				]
			});
		},

		_drawOtherSponsors() {
			if( !this.event.sponsors.other.length ) {
				return null;
			}
			let sponsors = mkE({
				tag: 'div',
				className: 'event-sponsors'
			});
			this.event.sponsors.other.forEach(sponsor => {
				mkE({
					tag: 'div',
					className: 'event-sponsor',
					els: [
						{
							tag: 'img',
							src: sponsor.image.original,
							attr: {
								alt: sponsor.name
							}
						}
					]
				}).append(sponsors);
			});
			return mkE({
				tag: 'div',
				className: 'event-sponsors-other',
				els: [
					{
						tag: 'h2',
						text: D.Lang.get('event.sponsors.other_title')
					},
					sponsors
				]
			});
		},

		onShow: function () {
			D.onLoad('Glide', D.closure(this, function () {
				this._galleries.forEach(gallery => {
					gallery.draw();
				});
			}));
			if( this._experienceVideo ) {
				let promise = this._experienceVideo.play();

				if( promise !== undefined ) {
					promise.catch(function () {
					});
				}
			}
			if( this._howTo ) {
				this._howTo.onShow();
			}
			if( this._testimonials ) {
				this._testimonials.onShow();
			}
			if( this._prizeSpoonsorsSlider ) {
				this._prizeSpoonsorsSlider.onShow();
			}
			this._checkDescriptionLength();
		},

		onLeave: function () {
			if( this._howTo ) {
				this._howTo.onLeave();
			}
			T.Popup.close();
		},

		_drawTestimonials: function () {
			this._testimonials = T.Quotes.get('event');
			if( this._testimonials ) {
				mkE({
					tag: 'div',
					className: 'testimonials-wrapper',
					els: [
						this._testimonials
					]
				}).append(this.node);
			}
		},

		_drawPrizes: function () {
			//zemgale 2020
			if( D.LANG !== 'lv' || this.event.id !== 17 ) {
				return;
			}
			const prizes = [
				{name: 'aerodium', title: 'Aerodium'},
				{name: 'rudolfs', title: 'Rūdolfs'},
				{name: 'kraces', title: 'Krāces'},
				{name: 'circle-k', title: 'Circle-K'}
			];
			const sponsors = [
				{name: 'circle-k', title: 'Circle-K'},
				{name: 'sigulda', title: 'Adventures'},
				{name: 'ltips', title: 'L Tips Agency'},
				{name: 'rudolfs', title: 'Rūdolfs'},
				{name: 'home3', title: 'Home3'},
				{name: 'illusion', title: 'Illusion'},
				{name: 'quest', title: 'Quest Lab'},
				{name: 'kino', title: 'Kino ferma'},
				{name: 'xroom', title: 'Xroom'},
				{name: 'kraces', title: 'Krāces'},
				{name: 'abra', title: 'Abra'},
				{name: 'kugrenu-vins', title: 'Kugrēnu vīna darītava'},
				{name: 'rigas-vilni', title: 'Rīgas Viļņi'},
				{name: 'carguru', title: 'CARGURU'},
				{name: 'virsotne', title: 'Virsotne'},
				{name: 'ziedona', title: 'Ziedoņa klase'},
				{name: 'riga-kayak', title: 'Riga kayaking'},
				{name: 'RiverCruises', title: 'River Cruises'},
				{name: 'VRgaming', title: 'VR Gaming'},
				{name: 'dumini', title: 'Vīna darītava Dūmiņi'},
				{name: 'spridisi', title: 'Muzejs "Sprīdīši"'}
			];
			mkE({
				tag: 'div',
				className: 'container single-event-prizes',
				els: [
					{
						tag: 'div',
						className: 'single-event-block',
						els: [
							{
								tag: 'div',
								className: 'title',
								text: D.Lang.get('event.prize.title')
							},
							{
								tag: 'div',
								className: 'wrapper',
								els: [
									{
										tag: 'div',
										className: 'text',
										innerHTML: D.Lang.get('event.prize.text')
									},
									{
										tag: 'div',
										className: 'image',
										els: [
											function () {
												const base = '/assets/images/single-event/prizes/zemgale-2020/', name = 'hurts',
													title = 'Hurts';
												return {
													tag: 'img',
													src: base + name + '.png',
													alt: title,
													attr: {
														srcset: `${base + name}.png 1x, ${base + name}@2x.png 2x, ${base + name}@3x.png 3x, `
													}
												};
											}()
										]
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'prize-images',
						els: function () {
							let re = [];
							const base = '/assets/images/single-event/prizes/zemgale-2020/';
							for( let i = 0; i < prizes.length; i++ ) {
								const sponsor = prizes[i];
								re.push({
									tag: 'img',
									src: base + sponsor.name + '.png',
									alt: sponsor.title,
									attr: {
										srcset: `${base + sponsor.name}.png 1x, ${base + sponsor.name}@2x.png 2x, ${base + sponsor.name}@3x.png 3x, `
									}
								});
							}
							return re;
						}()
					},
					{
						tag: 'div',
						className: 'single-event-block prize-sponsors',
						els: [
							{
								tag: 'div',
								className: 'title',
								text: D.Lang.get('event.prize.sponsors.title')
							},
							{
								tag: 'div',
								className: 'list',
								els: function () {
									let re = [];
									const base = '/assets/images/single-event/prizes/zemgale-2020/sponsors/';
									for( let i = 0; i < sponsors.length; i++ ) {
										const sponsor = sponsors[i];
										re.push({
											tag: 'div',
											className: 'item',
											els: [
												{
													tag: 'img',
													src: base + sponsor.name + '.png',
													alt: sponsor.title,
													attr: {
														srcset: `${base + sponsor.name}.png 1x, ${base + sponsor.name}@2x.png 2x, ${base + sponsor.name}@3x.png 3x, `
													}
												}
											]
										});
									}
									return re;
								}()
							}
						]
					}
				]
			}).append(this.node);
		},

		_drawExperience() {
			let items = [];
			if( Number(D.Lang.get('event.events.' + this.event.id + '.experience.items.count') || 0) ) {
				for( let i = 0; i < Number(D.Lang.get('event.events.' + this.event.id + '.experience.items.count')); i++ ) {
					items.push(D.Lang.get('event.events.' + this.event.id + '.experience.items.' + i));
				}
			} else if( Number(D.Lang.get('event.experience.items.count') || 0) ) {
				for( let i = 0; i < Number(D.Lang.get('event.experience.items.count')); i++ ) {
					items.push(D.Lang.get('event.experience.items.' + i));
				}
			}
			let list = null;
			let listItems = [];
			let hours = (this.event.endTime - this.event.startTime) / 3600;
			if( this.event.settings.manualStart ) {
				hours = this.event.settings.gameTime / 60;
			}
			if( Array.isArray(items) && items.length ) {
				items.forEach(item => {
					item = item.replace('#HOURS#', hours);
					listItems.push({
						tag: 'li',
						text: item
					});
				});
			}
			if( listItems.length ) {
				list = mkE({
					tag: 'ul',
					className: 'default-list default-list-small',
					els: listItems
				});
			}
			let experienceVideoSource = D.Lang.get('event.events.' + this.event.id + '.experience.video', D.Lang.get('event.experience.video'));
			let experienceYoutube = D.Lang.get('event.events.' + this.event.id + '.experience.youtube', D.Lang.get('event.experience.youtube'));
			if( experienceYoutube == false ) {
				experienceYoutube = null;
			}
			let experienceImage = false;
			if( this.event.settings.manualStart || this.isRace ) {
				experienceVideoSource = null;
				experienceImage = true;
			}
			if( experienceVideoSource ) {
				this._experienceVideo = mkE({
					tag: 'video',
					src: experienceVideoSource,
					attr: {
						autoplay: true,
						muted: true,
						loop: true,
						preload: 'metadata',
						poster: '/assets/images/event/experience-video/poster.png',
						playsinline: true
					}
				});
				this._experienceVideo.addEventListener('play', () => {
					addClassName(this._experienceVideoContainer, 'playing');
				});
			}
			let text2 = D.Lang.get('event.events.' + this.event.id + '.experience.text2', D.Lang.get('event.experience.text2'));
			text2 = text2.replace('#TITLE#', this.event.title)
			mkE({
				tag: 'div',
				id: 'event-experience',
				className: 'container single-event-experience',
				els: [
					{
						tag: 'div',
						className: 'single-event-block',
						els: [
							{
								tag: 'div',
								className: 'caption',
								text: D.Lang.get('event.experience.caption')
							},
							{
								tag: 'h2',
								className: 'title',
								text: D.Lang.get('event.experience.title')
							},
							{
								tag: 'p',
								className: 'text',
								text: D.Lang.get('event.experience.text')
							},
							list,
							{
								tag: 'p',
								className: 'text',
								text: text2
							}
						]
					},
					experienceImage ? {
						tag: 'div',
						className: 'experience-image',
						els: [
							{
								tag: 'img',
								src: '/assets/images/experience-image-2.png'
							}
						]
					} : null,
					experienceVideoSource ? {
						tag: 'div',
						className: 'experience-video',
						els: [
							this._experienceVideoContainer = mkE({
								tag: 'a',
								href: experienceYoutube ? `https://www.youtube.com/watch?v=${experienceYoutube}` : experienceVideoSource,
								target: '_blank',
								onclick: experienceYoutube ? this._showExperienceVideo : null,
								els: [
									this._experienceVideo
								]
							}),
							experienceYoutube ? {
								tag: 'div',
								className: 'video-iframe',
								els: [
									D.cookieConsent('marketing', mkE({
										tag: 'iframe',
										style: {
											overflow: 'hidden',
											height: '100%',
											width: '100%'
										},
										src: `https://www.youtube-nocookie.com/embed/${experienceYoutube}?rel=0`,
										attr: {
											frameborder: 0,
											allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
											allowfullscreen: ''
										}
									}))
								]
							} : ''
						]
					} : null
				]
			}).append(this.node);
		},

		_showExperienceVideo() {
			let experienceYoutube = D.Lang.get('event.events.' + this.event.id + '.experience.youtube', D.Lang.get('event.experience.youtube'));
			T.Popup.video(D.cookieConsent('marketing', mkE({
				tag: 'iframe',
				style: {
					overflow: 'hidden',
					height: '100%',
					width: '100%'
				},
				src: `https://www.youtube-nocookie.com/embed/${experienceYoutube}?autoplay=1&rel=0`,
				attr: {
					frameborder: 0,
					allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
					allowfullscreen: ''
				}
			})));
			return false;
		},

		_drawGallery() {
			if( this.event.id === 1 ) {
				let gallery1 = new SectionEvent.Base.Gallery([
					['122'],
					['679', '213', '68', '93'],
					['553'],
					['542', '679-2', '170', '68-2']
				], '/assets/images/event/gallery/', 'png');
				this._galleries.push(gallery1);

				let gallery2 = new SectionEvent.Base.Gallery([
					['679-2', '213-copy', '68-2', '93-copy'],
					['553-copy'],
					['542-copy', '170-copy', '170-copy', '542'],
					['122-copy']
				], '/assets/images/event/gallery/', 'png');
				this._galleries.push(gallery2);

				let gallery3 = new SectionEvent.Base.Gallery([
					['122-copy-2'],
					['679-copy-2', '213-copy-2', '68-copy-2', '93-copy-2'],
					['553-copy-2'],
					['542-copy-2', '170', '170-copy-2', '542']
				], '/assets/images/event/gallery/', 'png');
				this._galleries.push(gallery3);
			} else if( this.event.id === 7 ) {
				let gallery1 = new SectionEvent.Base.Gallery([
					['122'],
					['679', '213', '68', '93'],
					['553'],
					['542', '542-copy-5', '170', '170-copy-5']
				], '/assets/images/event/kurzeme/gallery/');
				this._galleries.push(gallery1);

				let gallery2 = new SectionEvent.Base.Gallery([
					['679-copy', '213-copy', '68-copy', '93-copy'],
					['553-copy'],
					['542-copy', '542-copy-3', '170-copy', '170-copy-3'],
					['122-copy']
				], '/assets/images/event/kurzeme/gallery/');
				this._galleries.push(gallery2);

				let gallery3 = new SectionEvent.Base.Gallery([
					['122-copy-2'],
					['679-copy-2', '213-copy-2', '68-copy-2', '93-copy-2'],
					['553-copy-2'],
					['542-copy-2', '542-copy-4', '170-copy-2', '170-copy-4']
				], '/assets/images/event/kurzeme/gallery/');
				this._galleries.push(gallery3);
			} else {
				let slides = [
					['1'],
					['2', '3', '4', '5'],
					['6'],
					['7', '8', '9', '10']
				];
				let gallery = new SectionEvent.Base.Gallery(slides, '/assets/images/gallery/centrs/').append(this.node);
				this._galleries.push(gallery);
			}
			let els = this._galleries;
			if( this.event.id === 1 || this.event.id === 7 ) {
				let block = mkE({
					tag: 'div',
					className: 'single-event-block container',
					els: [
						{
							tag: 'div',
							className: 'caption',
							text: D.Lang.get('event.finished.gallery.caption')
						},
						{
							tag: 'h2',
							className: 'title h1',
							text: D.Lang.get('event.finished.gallery.title')
						}
					]
				});
				els = [block].concat(els);
			}
			mkE({
				tag: 'div',
				className: 'single-event-gallery',
				els: els
			}).append(this.node);
		},

		_drawShare() {
			const url = new Get('https://www.roadgames.com/' + D.LANG + '/event/' + this.event.seoTitle);
			url.add('utm_medium', 'social');
			url.add('utm_campaign', 'event-share');
			url.add('utm_content', this.event.id);

			url.add('utm_source', 'facebook.com');
			const shareFacebook = new Get('https://www.facebook.com/sharer/sharer.php').add('u', url.toUrl());
			url.add('utm_source', 'draugiem.lv');
			const shareDraugiem = new Get('https://www.draugiem.lv/say/ext/add.php').add('title', '').add('link', url.toUrl());
			url.add('utm_source', 'twitter.com');
			const shareTwitter = new Get('https://twitter.com/share').add('text', '').add('url', url.toUrl());

			let className = ['share'];
			if( !navigator.share ) {
				className.push('force-social');
			}

			return mkE({
				tag: 'div',
				className: className.join(' '),
				els: [
					{
						tag: 'a',
						className: 'share-mobile',
						onclick: this.share,
						els: [
							D.svgIcon('share'),
							D.Lang.get('event.share')
						]
					},
					{
						tag: 'a',
						attr: {
							rel: 'nofollow'
						},
						target: '_blank',
						href: shareFacebook.toUrl(),
						title: 'facebook.com',
						els: [D.svgIcon('round-facebook')]
					},
					{
						tag: 'a',
						attr: {
							rel: 'nofollow'
						},
						target: '_blank',
						href: shareDraugiem.toUrl(),
						title: 'draugiem.lv',
						els: [D.svgIcon('round-draugiem')]
					},
					{
						tag: 'a',
						attr: {
							rel: 'nofollow'
						},
						target: '_blank',
						href: shareTwitter.toUrl(),
						title: 'twitter.com',
						els: [D.svgIcon('round-twitter')]
					}
				]
			});
		},

		_drawTopSponsors() {
			if( !this.event.sponsors.main.length ) {
				return;
			}
			let els = [];
			this.event.sponsors.main.forEach(sponsor => {
				let el = {
					tag: 'span',
					className: 'event-sponsor',
					els: [
						{
							tag: 'img',
							src: sponsor.image.large,
							attr: {
								alt: sponsor.name
							}
						}
					]
				};
				if( sponsor.url ) {
					el.tag = 'a';
					el.target = '_blank';
					el.attr = {rel: 'nofollow'};
					el.href = sponsor.url;
				}
				els.push(el);
			});
			mkE({
				tag: 'div',
				className: 'container single-event-top_sponsors',
				els: [
					{
						tag: 'p',
						className: 'title',
						text: D.Lang.get('event.top-sponsors.title')
					},
					{
						tag: 'div',
						className: 'event-sponsor-list',
						els: els
					}
				]
			}).append(this.node);
		},

		_drawPrizeSponsors() {
			if( !this.event.sponsors.prizes.length ) {
				return;
			}
			let prizes = [];
			for( let i = 0; i < this.event.sponsors.prizes.length; i++ ) {
				const item = this.event.sponsors.prizes[i];
				let el = {
					tag: 'span',
					className: 'item',
					style: {
						backgroundImage: `url('${item.image.large}')`
					},
					els: [
						{
							tag: 'p',
							text: item.description || item.name
						}
					]
				};
				if( item.url ) {
					el.tag = 'a';
					el.target = '_blank';
					el.attr = {rel: 'nofollow'};
					el.href = item.url;
				}
				prizes.push(el);
			}
			mkE({
				tag: 'div',
				id: 'prize-sponsors',
				className: 'container single-event-sponsor_prizes',
				els: [
					{
						tag: 'h2',
						text: D.Lang.get('event.prize_sponsors.title')
					},
					this._prizeSpoonsorsSlider = new T.Slider(prizes)
				]
			}).append(this.node);
		},

		_drawLiveAwards() {
			if( !this.event.settings.hasLivestream ) {
				return;
			}
			let video;
			let bgUrl = '';
			let videoId;
			if ((this.livestream && this.livestream.youtubeId) || this.event.settings.awardVideoUrl) {
				let url;
				if (this.livestream && this.livestream.youtubeId) {
					url = `https://www.youtube-nocookie.com/embed/${this.livestream.youtubeId}?autoplay=1&rel=0`;
					videoId = this.livestream.youtubeId;
				} else {
					url = this.event.settings.awardVideoUrl;
					const match = url.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?(?<id>[^#&?]*).*/);
					if (match.groups.id) {
						url = `https://www.youtube-nocookie.com/embed/${match.groups.id}?autoplay=1&rel=0`;
						videoId = match.groups.id;
					}
				}
				let bgStyle = {};
				if (videoId) {
					bgUrl = `https://i3.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
					bgStyle.backgroundImage = `url('${bgUrl}')`
				}
				video = mkE({
					tag: 'span',
					className: 'award-video',
					onclick: () => {
						T.Popup.video(mkE({
							tag: 'iframe',
							style: {
								overflow: 'hidden',
								height: '100%',
								width: '100%'
							},
							src: url,
							attr: {
								frameborder: 0,
								allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
								allowfullscreen: ''
							}
						}));
					},
					style: bgStyle,
					els: [
						{
							tag: 'span',
							els: [
								D.svgIcon('play')
							]
						}
					]
				});
			} else {
				video = mkE({
					tag: 'span',
					className: 'award-video'
				});
			}
			if (videoId && bgUrl) {
				let image = new Image();
				image.onload = (e) => {
					if (e.target.naturalWidth < 240) {
						video.style.backgroundImage = null;
					}
				}
				image.onerror = () => {
					video.style.backgroundImage = null;
				}
				image.src = bgUrl;
			}
			mkE({
				tag: 'div',
				id: 'event-live-awards',
				className: 'container single-event-live_awards',
				els: [
					{
						tag: 'div',
						els: [
							{
								tag: 'p',
								text: D.Lang.get('events.live-awards.description')
							}
						]
					},
					{
						tag: 'div',
						els: [
							video
						]
					}
				]
			}).append(this.node);
		},

		_drawApiGallery() {
			const par = {};
			if( !this.isRace && this.event.regionImage ) {
				this.event.gallery.unshift(new DR.roadgames.struct.Pic({
					image: this.event.regionImage
				}));
				par.overlay = mkE({
					tag: 'div',
					className: 'region-image',
					els: [
						{tag: 'small', text: D.Lang.get('event.infoblock.region.title')},
						{tag: 'p', text: this.event.region}
					]
				});
			}
			if( !this.event.gallery.length ) {
				return;
			}
			mkE({
				tag: 'div',
				id: 'gallery',
				className: 'container single-event-api_gallery',
				els: [
					{
						tag: 'h2',
						text: D.Lang.get('events.gallery.title')
					},
					{
						tag: 'div',
						els: [
							this.gallery = new T.GalleryBlock(this.event.gallery, par)
						]
					}
				]
			}).append(this.node);
		},

		_drawInstagramFeed() {
			new T.InstagramFeed().append(this.node);
		},

		_drawGiftCards() {
			mkE({
				tag: 'div',
				className: 'container single-event-giftcards',
				els: [
					{
						tag: 'div',
						id: 'giftcards',
						els: [
							{
								tag: 'div',
								className: 'banner',
								els: [
									{tag: 'span', className: 'icon'},
									{tag: 'span', className: 'text', text: D.Lang.get('event.giftcards.banner.text')},
									{
										tag: 'a',
										href: D.url('/gift-card/' + this.event.seoTitle),
										className: 'button button-turquoise',
										text: D.Lang.get('event.giftcards.banner.button')
									},
									{tag: 'div', className: 'clear'}
								]
							}
						]
					}
				]
			}).append(this.node);
		},

		share() {
			if( navigator.share ) {
				navigator
					.share({
						title: this.event.title,
						//text: this.event.description,
						url: D.url('event/' + this.event.seoTitle)
					})
					.catch(err => {
						if( err.name === 'AbortError' ) {
							return;
						}
						addClassName(this._shareNode, 'force-social');
						console.error(err);
					});
			}
		}
	},
	mkE.Base
);

/**
 * @param {DR.events.struct.Event} event
 * @param {DR.events.struct.Stats} stats
 * @param {DR.events.struct.DiscountData|null} discountData
 * @param {DR.events.struct.Livestream|null} livestream
 */
RoadgamesEvent.Base.get = function ( event, stats, discountData, livestream ) {
	let className;

	switch( event.status ) {
		case DR.events.struct.Event.STATUS_REGISTRATION:
			if( event.settings.gameType === 'race' ) {
				className = RoadgamesEvent.Registration.Race;
			} else {
				className = RoadgamesEvent.Registration;
			}
			break;
		case DR.events.struct.Event.STATUS_NOT_STARTED:
		case DR.events.struct.Event.STATUS_STARTED:
		case DR.events.struct.Event.STATUS_ENDED:
			if( event.settings.gameType === 'race' ) {
				className = RoadgamesEvent.InProgress.Race;
			} else {
				className = RoadgamesEvent.InProgress;
			}
			break;
		case DR.events.struct.Event.STATUS_FINISHED:
			if( event.showResults ) {
				className = RoadgamesEvent.Finished;
			} else {
				className = RoadgamesEvent.InProgress;
			}
			break;
		default:
			className = RoadgamesEvent.Base;
			break;
	}
	if( event.ticket.canPurchase && !event.hasTeam ) {
		if( event.settings.gameType === 'race' ) {
			className = RoadgamesEvent.Registration.Race;
		} else {
			className = RoadgamesEvent.Registration;
		}
	}

	//#temp
	if( event.id === 365 || event.id === 717 ) {
		className = RoadgamesEvent.Special;
	}

	return new className(event, stats, discountData, livestream);
};

/**
 * @param {DR.events.struct.Event} event
 * @return {string[]}
 */
RoadgamesEvent.getEventTasks = function(event) {
	let tasks = [];
	if( event.settings.hasPhotoMatching ) {
		tasks.push('matchmaker');
	}
	if( event.settings.hasHotCold ) {
		tasks.push('g-spot');
	}
	if( event.settings.hasQuestions ) {
		tasks.push('explorer');
	}
	if( event.settings.hasPacman ) {
		tasks.push('sprinter');
	}
	if( event.settings.hasTreasure ) {
		tasks.push('hunter');
	}
	if( event.settings.hasCrazyWolves ) {
		tasks.push('groupie');
	}
	if( event.settings.hasBrainTeaser ) {
		tasks.push('expert');
	}
	if( event.settings.hasDetective ) {
		tasks.push('detective');
	}
	if( event.settings.hasCoder ) {
		tasks.push('coder');
	}
	if( event.settings.hasGoldDigger ) {
		tasks.push('golddigger');
	}
	return tasks;
}

/**
 * @param {DR.events.struct.Event} event
 * @param {string} suffix
 * @return {string}
 */
RoadgamesEvent.getEventDuration = function ( event, suffix = 'h' ) {
	const t = event.settings.gameTime || ((event.endTime - event.startTime) / 60);
	const ext = event.settings.hasTimeExtension ? '+' : '';
	if( t < 60 ) {
		return `${t}m${ext}`;
	} else {
		return `${(t / 60).toFixed(t / 60 % 1 ? 1 : 0)}${suffix}${ext}`;
	}
}